import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
    FaYoutube,
    FaMapMarkerAlt,
    FaClock,
    FaEnvelope,
    FaPhone,
    FaArrowRight,
    FaFacebookF,
} from "react-icons/fa";

import ContactFB from "../../assets/minmin.jpg";
import "../../css/HomeContact.css";

const contactItems = [
    {
        icon: <FaMapMarkerAlt />,
        title: "Địa chỉ",
        description: (
            <>
                <strong>Home:</strong> 163D Đặng Thúc Vịnh, Ấp 38,
                xã Đông Thạnh, TP.HCM.
                <br />
                <strong>Studio:</strong> 275 Nguyễn Văn Quá,
                P.Đông Hưng Thuận, Q.12, TP.HCM.
            </>
        ),
        className: "address",
    },
    {
        icon: <FaClock />,
        title: "Thời gian làm việc",
        description: "08:00 – 20:00, tất cả các ngày trong tuần",
        className: "time",
    },
    {
        icon: <FaEnvelope />,
        title: "Email",
        description: "thienphan3030@gmail.com",
        href: "mailto:thienphan3030@gmail.com",
        className: "email",
    },
    {
        icon: <FaPhone />,
        title: "Điện thoại",
        description: "0703427959",
        href: "tel:0703427959",
        className: "phone",
    },
];

export default function HomeContact() {
    return (
        <section className="home-contact">
            <Container>
                {/* Tiêu đề */}
                <div className="home-contact-heading">
                    <span className="home-contact-eyebrow">
                        MIN MIN - Phóng Sự Cưới · LET'S CONNECT
                    </span>

                    <h2>
                        Biến ý tưởng của bạn
                        <br />
                        thành <span>những khung hình đáng nhớ.</span>
                    </h2>

                    <p>
                        Chúng tôi luôn sẵn sàng lắng nghe câu chuyện,
                        ý tưởng và đồng hành cùng bạn trong những dự án
                        hình ảnh tiếp theo.
                    </p>
                </div>

                {/* Nội dung liên hệ */}
                <Row className="g-4 home-contact-main">
                    <Col lg={7}>
                        <div className="home-contact-info">
                            <div className="home-contact-section-title">
                                <span>01</span>
                                <h3>Thông tin liên hệ</h3>
                            </div>

                            <Row className="g-3">
                                {contactItems.map((item) => (
                                    <Col sm={6} key={item.className}>
                                        <div className="home-contact-card">
                                            <div className="home-contact-icon">
                                                {item.icon}
                                            </div>

                                            <h4>{item.title}</h4>

                                            {item.href ? (
                                                <a
                                                    href={item.href}
                                                    className="home-contact-value"
                                                >
                                                    {item.description}
                                                </a>
                                            ) : (
                                                <div className="home-contact-value">
                                                    {item.description}
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                ))}
                            </Row>

                            <div className="home-contact-note">
                                <span className="home-contact-note-line" />
                                <p>
                                    Một ý tưởng hay xứng đáng có
                                    những khung hình đẹp.
                                </p>
                            </div>

                            <a
                                href="tel:0703427959"
                                className="home-contact-cta"
                            >
                                Liên hệ ngay
                                <FaArrowRight />
                            </a>
                        </div>
                    </Col>

                    {/* Facebook */}
                    <Col lg={5}>
                        <div className="home-contact-social-card">
                            <div className="home-contact-social-top">
                                <div>
                                    <span className="home-contact-social-label">
                                        CONNECT WITH US
                                    </span>

                                    <h3>
                                        Theo dõi hành trình
                                        <br />
                                        của  MINMIN WEDDING - PHÓNG SỰ CƯỚI
                                    </h3>
                                </div>

                                <FaFacebookF className="home-contact-facebook-icon" />
                            </div>

                            <div className="home-contact-facebook-image">
                                <img
                                    src={ContactFB}
                                    alt="Facebook "
                                    loading="lazy"
                                />
                            </div>

                            <p>
                                Cập nhật hình ảnh, dự án mới và những
                                khoảnh khắc hậu trường cùng chúng tôi.
                            </p>

                            <a
                                href="https://www.facebook.com/MinMinMedia01"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="home-contact-social-link"
                            >
                                Khám phá Facebook Min Min - Phóng Sự Cưới
                                <FaArrowRight />
                            </a>
                        </div>
                    </Col>
                </Row>

                {/* YouTube */}
                <div className="home-contact-youtube">
                    <div className="home-contact-youtube-content">
                        <div className="home-contact-youtube-icon">
                            <FaYoutube />
                        </div>

                        <div className="home-contact-youtube-text">
                            <span>MIN MIN - PHÓNG SỰ CƯỚI · WEDDING FILM</span>

                            <h3>
                                Những câu chuyện qua góc máy
                            </h3>

                            <p>
                                Khám phá các thước phim cưới,
                                những góc quay Flycam và tác phẩm
                                thực tế của chúng tôi.
                            </p>
                        </div>
                    </div>

                    <a
                        href="https://www.youtube.com/@thien_minweddingfilm6102"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="home-contact-youtube-button"
                    >
                        <FaYoutube />
                        Theo dõi YouTube
                        <FaArrowRight />
                    </a>
                </div>

                {/* Chân trang nhỏ */}
                <div className="home-contact-bottom">
                    <span>MIN MIN - PHÓNG SỰ CƯỚI</span>
                    <span>GHI LẠI KHOẢNH KHẮC · KỂ NHỮNG CÂU CHUYỆN</span>
                </div>
            </Container>
        </section>
    );
}